"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVerificationStatusResponseDto = instanceOfVerificationStatusResponseDto;
exports.VerificationStatusResponseDtoFromJSON = VerificationStatusResponseDtoFromJSON;
exports.VerificationStatusResponseDtoFromJSONTyped = VerificationStatusResponseDtoFromJSONTyped;
exports.VerificationStatusResponseDtoToJSON = VerificationStatusResponseDtoToJSON;
exports.VerificationStatusResponseDtoToJSONTyped = VerificationStatusResponseDtoToJSONTyped;
var VerificationStatusResponseData_1 = require("./VerificationStatusResponseData");
/**
 * Check if a given object implements the VerificationStatusResponseDto interface.
 */
function instanceOfVerificationStatusResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function VerificationStatusResponseDtoFromJSON(json) {
    return VerificationStatusResponseDtoFromJSONTyped(json, false);
}
function VerificationStatusResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, VerificationStatusResponseData_1.VerificationStatusResponseDataFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function VerificationStatusResponseDtoToJSON(json) {
    return VerificationStatusResponseDtoToJSONTyped(json, false);
}
function VerificationStatusResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, VerificationStatusResponseData_1.VerificationStatusResponseDataToJSON)(value['data']),
        'error': value['error'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
